import type { CveRecord } from "./types";

/**
 * Curated real CVE catalog. Scores, dates, CWE, and descriptions were retrieved
 * from NVD CVE API 2.0 on 2026-08-18. CISA KEV membership from catalogVersion
 * 2026.08.17. EPSS from FIRST.org API for date 2026-08-17.
 * Do not add invented CVE IDs to this file.
 */
export const CVE_CATALOG: CveRecord[] = [
  {
    id: "CVE-2021-44228",
    cvss: 10.0,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-20", "CWE-400", "CWE-502"],
    affectedProduct: "Apache Log4j2",
    affectedVersion: "2.0-beta9 through 2.15.0",
    published: "2021-12-10",
    lastModified: "2026-08-11",
    epss: {
      score: 0.99999,
      percentile: 1.0,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2021-44228",
    },
    kev: true,
    description: "Apache Log4j2 2.0-beta9 through 2.15.0 (excluding security releases 2.12.2, 2.12.3, and 2.3.1) JNDI features used in configuration, log messages, and parameters do not protect against attacker controlled LDAP and other JNDI related endpoints. An attacker who can control log messa",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2021-44228", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2021-44228",
      publicationDate: "2021-12-10",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2023-44487",
    cvss: 7.5,
    cvssVersion: "3.1",
    severity: "HIGH",
    cwe: ["CWE-400"],
    affectedProduct: "HTTP/2 implementations",
    affectedVersion: "protocol",
    published: "2023-10-10",
    lastModified: "2026-08-11",
    epss: {
      score: 0.99999,
      percentile: 0.99997,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2023-44487",
    },
    kev: true,
    description: "The HTTP/2 protocol allows a denial of service (server resource consumption) because request cancellation can reset many streams quickly, as exploited in the wild in August through October 2023.",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2023-44487", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2023-44487",
      publicationDate: "2023-10-10",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2023-34362",
    cvss: 9.8,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-89"],
    affectedProduct: "Progress MOVEit Transfer",
    affectedVersion: "before 2021.0.6 / 2023.0.1",
    published: "2023-06-02",
    lastModified: "2026-06-17",
    epss: {
      score: 0.99934,
      percentile: 0.9997,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2023-34362",
    },
    kev: true,
    description: "In Progress MOVEit Transfer before 2021.0.6 (13.0.6), 2021.1.4 (13.1.4), 2022.0.4 (14.0.4), 2022.1.5 (14.1.5), and 2023.0.1 (15.0.1), a SQL injection vulnerability has been found in the MOVEit Transfer web application that could allow an unauthenticated attacker to gain access to",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2023-34362", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2023-34362",
      publicationDate: "2023-06-02",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2024-3400",
    cvss: 10.0,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-20", "CWE-77"],
    affectedProduct: "Palo Alto Networks PAN-OS",
    affectedVersion: "GlobalProtect (specific versions)",
    published: "2024-04-12",
    lastModified: "2026-06-17",
    epss: {
      score: 0.99999,
      percentile: 1.0,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2024-3400",
    },
    kev: true,
    description: "A command injection as a result of arbitrary file creation vulnerability in the GlobalProtect feature of Palo Alto Networks PAN-OS software for specific PAN-OS versions and distinct feature configurations may enable an unauthenticated attacker to execute arbitrary code with root ",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2024-3400", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2024-3400",
      publicationDate: "2024-04-12",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2023-4966",
    cvss: 9.4,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-119"],
    affectedProduct: "Citrix NetScaler ADC/Gateway",
    affectedVersion: "Gateway or AAA virtual server",
    published: "2023-10-10",
    lastModified: "2026-07-31",
    epss: {
      score: 0.99999,
      percentile: 0.99998,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2023-4966",
    },
    kev: true,
    description: "Sensitive information disclosure in NetScaler ADC and NetScaler Gateway when configured as a Gateway (VPN virtual server, ICA Proxy, CVPN, RDP Proxy) or AAA  virtual server.",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2023-4966", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2023-4966",
      publicationDate: "2023-10-10",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2024-21887",
    cvss: 9.1,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-77"],
    affectedProduct: "Ivanti Connect Secure / Policy Secure",
    affectedVersion: "9.x, 22.x",
    published: "2024-01-12",
    lastModified: "2026-08-04",
    epss: {
      score: 0.99999,
      percentile: 0.99999,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2024-21887",
    },
    kev: true,
    description: "A command injection vulnerability in web components of Ivanti Connect Secure (9.x, 22.x) and Ivanti Policy Secure (9.x, 22.x)  allows an authenticated administrator to send specially crafted requests and execute arbitrary commands on the appliance.",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2024-21887", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2024-21887",
      publicationDate: "2024-01-12",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2023-22515",
    cvss: 9.8,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-20"],
    affectedProduct: "Atlassian Confluence Data Center/Server",
    affectedVersion: "publicly accessible instances",
    published: "2023-10-04",
    lastModified: "2026-06-17",
    epss: {
      score: 0.99156,
      percentile: 0.9993,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2023-22515",
    },
    kev: true,
    description: "Atlassian has been made aware of an issue reported by a handful of customers where external attackers may have exploited a previously unknown vulnerability in publicly accessible Confluence Data Center and Server instances to create unauthorized Confluence administrator accounts ",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2023-22515", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2023-22515",
      publicationDate: "2023-10-04",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2021-34527",
    cvss: 8.8,
    cvssVersion: "3.1",
    severity: "HIGH",
    cwe: [],
    affectedProduct: "Microsoft Windows Print Spooler",
    affectedVersion: "Windows",
    published: "2021-07-02",
    lastModified: "2026-08-10",
    epss: {
      score: 0.99792,
      percentile: 0.99957,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2021-34527",
    },
    kev: true,
    description: "A remote code execution vulnerability exists when the Windows Print Spooler service improperly performs privileged file operations. An attacker who successfully exploited this vulnerability could run arbitrary code with SYSTEM privileges. An attacker could then install programs; ",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2021-34527", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2021-34527",
      publicationDate: "2021-07-02",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2023-23397",
    cvss: 9.8,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-20", "CWE-294"],
    affectedProduct: "Microsoft Outlook",
    affectedVersion: "Office",
    published: "2023-03-14",
    lastModified: "2026-06-17",
    epss: {
      score: 0.97408,
      percentile: 0.99893,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2023-23397",
    },
    kev: true,
    description: "Microsoft Outlook Elevation of Privilege Vulnerability",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2023-23397", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2023-23397",
      publicationDate: "2023-03-14",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2024-21762",
    cvss: 9.8,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-787"],
    affectedProduct: "Fortinet FortiOS / FortiProxy",
    affectedVersion: "multiple versions",
    published: "2024-02-09",
    lastModified: "2026-08-04",
    epss: {
      score: 0.84285,
      percentile: 0.99676,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2024-21762",
    },
    kev: true,
    description: "A out-of-bounds write in Fortinet FortiOS versions 7.4.0 through 7.4.2, 7.2.0 through 7.2.6, 7.0.0 through 7.0.13, 6.4.0 through 6.4.14, 6.2.0 through 6.2.15, 6.0.0 through 6.0.17, FortiProxy versions 7.4.0 through 7.4.2, 7.2.0 through 7.2.8, 7.0.0 through 7.0.14, 2.0.0 through 2",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2024-21762", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2024-21762",
      publicationDate: "2024-02-09",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2022-22965",
    cvss: 9.8,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-94"],
    affectedProduct: "VMware Spring Framework",
    affectedVersion: "JDK 9+ Spring MVC/WebFlux",
    published: "2022-04-01",
    lastModified: "2026-06-17",
    epss: {
      score: 0.99677,
      percentile: 0.99949,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2022-22965",
    },
    kev: true,
    description: "A Spring MVC or Spring WebFlux application running on JDK 9+ may be vulnerable to remote code execution (RCE) via data binding. The specific exploit requires the application to run on Tomcat as a WAR deployment. If the application is deployed as a Spring Boot executable jar, i.e.",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2022-22965", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2022-22965",
      publicationDate: "2022-04-01",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2020-1472",
    cvss: 5.5,
    cvssVersion: "3.1",
    severity: "MEDIUM",
    cwe: [],
    affectedProduct: "Microsoft Netlogon (MS-NRPC)",
    affectedVersion: "Windows Server domain controllers",
    published: "2020-08-17",
    lastModified: "2026-06-17",
    epss: {
      score: 0.99512,
      percentile: 0.99942,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2020-1472",
    },
    kev: true,
    description: "An elevation of privilege vulnerability exists when an attacker establishes a vulnerable Netlogon secure channel connection to a domain controller, using the Netlogon Remote Protocol (MS-NRPC). An attacker who successfully exploited the vulnerability could run a specially crafted",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2020-1472", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2020-1472",
      publicationDate: "2020-08-17",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2021-26855",
    cvss: 9.1,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-918"],
    affectedProduct: "Microsoft Exchange Server",
    affectedVersion: "ProxyLogon chain",
    published: "2021-03-03",
    lastModified: "2026-08-12",
    epss: {
      score: 0.99999,
      percentile: 0.99991,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2021-26855",
    },
    kev: true,
    description: "Microsoft Exchange Server Remote Code Execution Vulnerability",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2021-26855", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2021-26855",
      publicationDate: "2021-03-03",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2023-46604",
    cvss: 10.0,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-502"],
    affectedProduct: "Apache ActiveMQ",
    affectedVersion: "OpenWire protocol",
    published: "2023-10-27",
    lastModified: "2026-06-17",
    epss: {
      score: 0.99723,
      percentile: 0.99953,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2023-46604",
    },
    kev: true,
    description: "The Java OpenWire protocol marshaller is vulnerable to Remote Code  Execution. This vulnerability may allow a remote attacker with network  access to either a Java-based OpenWire broker or client to run arbitrary  shell commands by manipulating serialized class types in the OpenW",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2023-46604", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2023-46604",
      publicationDate: "2023-10-27",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2024-4577",
    cvss: 9.8,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-78"],
    affectedProduct: "PHP CGI on Windows",
    affectedVersion: "8.1 before 8.1.29, 8.2 before 8.2.20, 8.3 before 8.3.8",
    published: "2024-06-09",
    lastModified: "2026-06-17",
    epss: {
      score: 0.99987,
      percentile: 0.99984,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2024-4577",
    },
    kev: true,
    description: "In PHP versions 8.1.* before 8.1.29, 8.2.* before 8.2.20, 8.3.* before 8.3.8, when using Apache and PHP-CGI on Windows, if the system is set up to use certain code pages, Windows may use \"Best-Fit\" behavior to replace characters in command line given to Win32 API functions. PHP C",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2024-4577", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2024-4577",
      publicationDate: "2024-06-09",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2023-3519",
    cvss: 9.8,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-94"],
    affectedProduct: "Citrix NetScaler ADC/Gateway",
    affectedVersion: "unauthenticated RCE",
    published: "2023-07-19",
    lastModified: "2026-08-05",
    epss: {
      score: 0.99749,
      percentile: 0.99954,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2023-3519",
    },
    kev: true,
    description: "Unauthenticated remote code execution",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2023-3519", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2023-3519",
      publicationDate: "2023-07-19",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2024-1709",
    cvss: 10.0,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-288"],
    affectedProduct: "ConnectWise ScreenConnect",
    affectedVersion: "23.9.7 and prior",
    published: "2024-02-21",
    lastModified: "2026-06-17",
    epss: {
      score: 0.99959,
      percentile: 0.99976,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2024-1709",
    },
    kev: true,
    description: "ConnectWise ScreenConnect 23.9.7 and prior are affected by an Authentication Bypass Using an Alternate Path or Channel   vulnerability, which may allow an attacker direct access to confidential information or   critical systems.",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2024-1709", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2024-1709",
      publicationDate: "2024-02-21",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2021-41773",
    cvss: 9.8,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-22"],
    affectedProduct: "Apache HTTP Server",
    affectedVersion: "2.4.49",
    published: "2021-10-05",
    lastModified: "2026-06-17",
    epss: {
      score: 0.99992,
      percentile: 0.99986,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2021-41773",
    },
    kev: true,
    description: "A flaw was found in a change made to path normalization in Apache HTTP Server 2.4.49. An attacker could use a path traversal attack to map URLs to files outside the directories configured by Alias-like directives. If files outside of these directories are not protected by the usu",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2021-41773", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2021-41773",
      publicationDate: "2021-10-05",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2024-1086",
    cvss: 7.8,
    cvssVersion: "3.1",
    severity: "HIGH",
    cwe: ["CWE-416"],
    affectedProduct: "Linux kernel nf_tables",
    affectedVersion: "netfilter",
    published: "2024-01-31",
    lastModified: "2026-08-07",
    epss: {
      score: 0.28058,
      percentile: 0.9794,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2024-1086",
    },
    kev: true,
    description: "A use-after-free vulnerability in the Linux kernel's netfilter: nf_tables component can be exploited to achieve local privilege escalation.    The nft_verdict_init() function allows positive values as drop error within the hook verdict, and hence the nf_hook_slow() function can c",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2024-1086", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2024-1086",
      publicationDate: "2024-01-31",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2023-38831",
    cvss: 7.8,
    cvssVersion: "3.1",
    severity: "HIGH",
    cwe: ["CWE-345", "CWE-351"],
    affectedProduct: "RARLAB WinRAR",
    affectedVersion: "before 6.23",
    published: "2023-08-23",
    lastModified: "2026-08-05",
    epss: {
      score: 0.97811,
      percentile: 0.99901,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2023-38831",
    },
    kev: true,
    description: "RARLAB WinRAR before 6.23 allows attackers to execute arbitrary code when a user attempts to view a benign file within a ZIP archive. The issue occurs because a ZIP archive may include a benign file (such as an ordinary .JPG file) and also a folder that has the same name as the b",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2023-38831", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2023-38831",
      publicationDate: "2023-08-23",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2023-20198",
    cvss: 10.0,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-420"],
    affectedProduct: "Cisco IOS XE Web UI",
    affectedVersion: "privilege 15 account creation",
    published: "2023-10-16",
    lastModified: "2026-06-17",
    epss: {
      score: 0.99571,
      percentile: 0.99944,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2023-20198",
    },
    kev: true,
    description: "Cisco is providing an update for the ongoing investigation into observed exploitation of the web UI feature in Cisco IOS XE Software. We are updating the list of fixed releases and adding the Software Checker. Our investigation has determined that the actors exploited two previou",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2023-20198", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2023-20198",
      publicationDate: "2023-10-16",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2021-21972",
    cvss: 9.8,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-22"],
    affectedProduct: "VMware vCenter Server",
    affectedVersion: "vSphere Client plugin, port 443",
    published: "2021-02-24",
    lastModified: "2026-08-12",
    epss: {
      score: 0.99518,
      percentile: 0.99943,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2021-21972",
    },
    kev: true,
    description: "The vSphere Client (HTML5) contains a remote code execution vulnerability in a vCenter Server plugin. A malicious actor with network access to port 443 may exploit this issue to execute commands with unrestricted privileges on the underlying operating system that hosts vCenter Se",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2021-21972", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2021-21972",
      publicationDate: "2021-02-24",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2022-41040",
    cvss: 8.8,
    cvssVersion: "3.1",
    severity: "HIGH",
    cwe: ["CWE-918"],
    affectedProduct: "Microsoft Exchange Server",
    affectedVersion: "ProxyNotShell SSRF",
    published: "2022-10-03",
    lastModified: "2026-06-17",
    epss: {
      score: 0.99956,
      percentile: 0.99975,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2022-41040",
    },
    kev: true,
    description: "Microsoft Exchange Server Elevation of Privilege Vulnerability",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2022-41040", "https://www.cisa.gov/known-exploited-vulnerabilities-catalog"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2022-41040",
      publicationDate: "2022-10-03",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2023-38545",
    cvss: 9.8,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-787"],
    affectedProduct: "curl SOCKS5",
    affectedVersion: "heap overflow in proxy handshake",
    published: "2023-10-18",
    lastModified: "2026-06-17",
    epss: {
      score: 0.78483,
      percentile: 0.99547,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2023-38545",
    },
    kev: false,
    description: "This flaw makes curl overflow a heap based buffer in the SOCKS5 proxy handshake.  When curl is asked to pass along the host name to the SOCKS5 proxy to allow that to resolve the address instead of it getting done by curl itself, the maximum length that host name can be is 255 byt",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2023-38545"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2023-38545",
      publicationDate: "2023-10-18",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2021-23337",
    cvss: 7.2,
    cvssVersion: "3.1",
    severity: "HIGH",
    cwe: ["CWE-94"],
    affectedProduct: "lodash",
    affectedVersion: "versions prior to 4.17.21",
    published: "2021-02-15",
    lastModified: "2026-06-17",
    epss: {
      score: 0.21333,
      percentile: 0.9739,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2021-23337",
    },
    kev: false,
    description: "Lodash versions prior to 4.17.21 are vulnerable to Command Injection via the template function.",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2021-23337"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2021-23337",
      publicationDate: "2021-02-15",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
  {
    id: "CVE-2024-3094",
    cvss: 10.0,
    cvssVersion: "3.1",
    severity: "CRITICAL",
    cwe: ["CWE-506"],
    affectedProduct: "xz-utils / liblzma",
    affectedVersion: "5.6.0 and 5.6.1 tarballs",
    published: "2024-03-29",
    lastModified: "2026-06-17",
    epss: {
      score: 0.85974,
      percentile: 0.99712,
      date: "2026-08-17",
      source: "FIRST.org EPSS API",
      sourceUrl: "https://api.first.org/data/v1/epss?cve=CVE-2024-3094",
    },
    kev: false,
    description: "Malicious code was discovered in the upstream tarballs of xz, starting with version 5.6.0.   Through a series of complex obfuscations, the liblzma build process extracts a prebuilt object file from a disguised test file existing in the source code, which is then used to modify sp",
    references: ["https://nvd.nist.gov/vuln/detail/CVE-2024-3094"],
    provenance: {
      kind: "intel",
      source: "NVD CVE API 2.0",
      sourceUrl: "https://nvd.nist.gov/vuln/detail/CVE-2024-3094",
      publicationDate: "2024-03-29",
      retrievedAt: "2026-08-18",
      datasetVersion: "nvd-2.0+cisa-kev-2026.08.17+epss-2026-08-17",
      metricDefinition: "NVD CVSS v3.1 base score; CISA KEV membership as of catalogVersion 2026.08.17; FIRST EPSS 30-day exploitation probability.",
    },
  },
];

export const CVE_BY_ID: Record<string, CveRecord> = Object.fromEntries(CVE_CATALOG.map((c) => [c.id, c]));
export const KEV_CVES = CVE_CATALOG.filter((c) => c.kev);
